import {
  Brain, BarChart3, Bell, Target, TrendingUp, Users,
  Star, Zap, Crown,
} from 'lucide-react';

export const FEATURES = [
  { icon: Brain, title: 'Sócrates', description: 'Predicciones avanzadas usando el motor Sócrates de última generación', color: 'from-purple-500 to-pink-500' },
  { icon: BarChart3, title: 'Analisis Estadistico', description: 'Frecuencias, tendencias y patrones de todos los sorteos', color: 'from-blue-500 to-cyan-500' },
  { icon: Bell, title: 'Notificaciones Push', description: 'Alertas 15 minutos antes de cada sorteo importante', color: 'from-amber-500 to-orange-500' },
  { icon: Target, title: 'Multiples Estrategias', description: 'Conservadora, balanceada o arriesgada segun tu preferencia', color: 'from-green-500 to-emerald-500' },
  { icon: TrendingUp, title: 'Numeros Calientes y Frios', description: 'Identifica numeros en racha o rezagados', color: 'from-red-500 to-rose-500' },
  { icon: Users, title: 'Sistema de Afiliados', description: 'Gana comisiones invitando amigos (20%, 10%, 5%)', color: 'from-indigo-500 to-violet-500' },
];

export const LOTTERIES = [
  { name: 'Nacional', region: 'RD', color: '#22c55e' },
  { name: 'Leidsa', region: 'RD', color: '#3b82f6' },
  { name: 'Loteka', region: 'RD', color: '#f59e0b' },
  { name: 'Real', region: 'RD', color: '#ef4444' },
  { name: 'La Primera', region: 'RD', color: '#8b5cf6' },
  { name: 'Florida', region: 'USA', color: '#06b6d4' },
  { name: 'New York', region: 'USA', color: '#ec4899' },
  { name: 'Gana Mas', region: 'RD', color: '#14b8a6' },
];

export const PLANS = [
  {
    id: 'basic', name: 'Basico', price: 19.99, period: '/mes', icon: Star,
    color: 'from-blue-500 to-blue-600', popular: false,
    features: ['1 loteria disponible', '1 recomendacion diaria', 'Estrategia conservadora', 'Historial de 7 dias', 'Soporte por email'],
    notIncluded: ['Numeros calientes/frios', 'Sócrates', 'Analisis avanzado'],
  },
  {
    id: 'premium', name: 'Premium', price: 39.99, period: '/mes', icon: Zap,
    color: 'from-purple-500 to-purple-600', popular: true,
    features: ['3 loterias disponibles', '4 recomendaciones diarias', 'Estrategias conservadora y balanceada', 'Numeros calientes y frios', 'Historial de 30 dias', 'Analisis avanzado', 'Soporte prioritario'],
    notIncluded: ['Sócrates'],
  },
  {
    id: 'vip', name: 'VIP', price: 59.99, period: '/mes', icon: Crown,
    color: 'from-amber-500 to-orange-500', popular: false,
    features: ['Todas las loterias', 'Recomendaciones ilimitadas', 'Todas las estrategias', 'Sócrates', 'Historial completo', 'Analisis premium', 'Soporte VIP 24/7', 'Acceso anticipado a nuevas funciones'],
    notIncluded: [],
  },
];

export const STEPS = [
  { number: '01', title: 'Crea tu cuenta', description: 'Registrate gratis en menos de 1 minuto', icon: Users },
  { number: '02', title: 'Elige tu plan', description: 'Selecciona el plan que mejor se adapte a ti', icon: Crown },
  { number: '03', title: 'Recibe predicciones', description: 'Obten numeros recomendados basados en Sócrates', icon: Brain },
];

export const TESTIMONIALS = [
  { name: 'Carlos R.', location: 'Santo Domingo', text: 'Increible herramienta. Sócrates me dio numeros que salieron la semana pasada. Muy recomendado!', avatar: 'CR', plan: 'VIP' },
  { name: 'Maria L.', location: 'Santiago', text: 'Las notificaciones antes de cada sorteo son muy utiles. Ya no me pierdo ninguno.', avatar: 'ML', plan: 'Premium' },
  { name: 'Jose M.', location: 'La Romana', text: 'El analisis de numeros calientes y frios me ayuda a tomar mejores decisiones.', avatar: 'JM', plan: 'Premium' },
];

export const FAQS = [
  { question: 'Como funciona NumeroMaestro?', answer: 'NumeroMaestro analiza datos historicos de todas las loterias dominicanas usando el motor Sócrates avanzado para identificar patrones y generar recomendaciones de numeros basadas en estadisticas reales.' },
  { question: 'Las predicciones garantizan que voy a ganar?', answer: 'No. NumeroMaestro es una herramienta de analisis estadistico que proporciona informacion para ayudarte a tomar decisiones mas informadas. Los juegos de azar son aleatorios y ningun sistema puede garantizar resultados.' },
  { question: 'Puedo cancelar mi suscripcion en cualquier momento?', answer: 'Si, puedes cancelar tu suscripcion cuando quieras desde tu panel de usuario. No hay contratos ni penalizaciones. Tu acceso continuara hasta el final del periodo pagado.' },
  { question: 'Como funciona el programa de afiliados?', answer: 'Ganas comisiones cuando tus referidos se suscriben: 20% en el primer nivel (referidos directos), 10% en el segundo nivel, y 5% en el tercer nivel. Puedes retirar tus ganancias cuando alcances $20 minimo.' },
  { question: 'Que metodos de pago aceptan?', answer: 'Puedes solicitar pagos por Zelle, Cash App o PayPal, según los métodos configurados. Verificamos cada pago antes de activar tu compra.' },
];
